export const Environments = {
  SIBIU: 'sibiu',
  TGMURES: 'tgmures',
  SLOBOZIA: 'slobozia',
  CARGES: 'carges',
  ROVINARI: 'rovinari',
  PITESTI: 'pitesti',
};

export const PriorityCountries = {
  ROMANIA: 'Romania',
};

const PriorityDistricts = {
  ARGES: 'Arges',
  SIBIU: 'Sibiu',
  MURES: 'Mures',
  IALOMITA: 'Ialomita',
};

export const EnvToPriorityDistrictMap = {
  [Environments.PITESTI]: PriorityDistricts.ARGES,
  [Environments.SIBIU]: PriorityDistricts.SIBIU,
  [Environments.TGMURES]: PriorityDistricts.MURES,
  [Environments.SLOBOZIA]: PriorityDistricts.IALOMITA,
  [Environments.CARGES]: PriorityDistricts.ARGES,
};

export const ALLOWED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/bmp',
  'application/pdf',
];

export const ALLOWED_FILE_ACCEPT = '.jpeg,.jpg,.pdf,.png,.bmp';
